<!-- app-loader intentionally removed: this popup's own loading moments now
     use a local skeleton/button state (see isLoadingPaymentMethods,
     isProcessingPayment) instead of the global spinner. Any other page's
     loaderService.show() calls are still served by whichever <app-loader>
     is part of the persistent app shell (e.g. the header). -->

<!-- Add Balance Modal -->
<div *ngIf="showModal"
  class="fixed inset-0 wallet-modal-backdrop flex items-center justify-center modal-overlay Add_Bal z-[999] px-3 sm:px-4"
  (click)="hideWalletModal()">
  <div class="wallet-modal-shell w-full max-w-xl max-h-[85vh] flex flex-col" (click)="$event.stopPropagation()">
    <div class="wallet-modal-scroll">
      <!-- Header -->
      <div class="flex items-start justify-between gap-4 mb-3 sm:mb-5">
        <div class="flex items-center gap-3">
          <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-[#C71650]/40 to-[#0D070C] border border-[#E7CA96]/40 flex items-center justify-center flex-shrink-0 shadow-[0_0_16px_rgba(231,202,150,0.25)]">
            <i class="fas fa-vault text-[#E7CA96] text-xl"></i>
          </div>

          <div>
            <h2 class="wallet-modal-title !text-xl !font-extrabold !text-[#F6E9D5] tracking-wide">DEPOSIT CASHIER VAULT</h2>
            <p class="wallet-modal-subtitle !text-xs !text-[#9C837C]">
              Select a secure funding channel to inject liquid balance
            </p>
          </div>
        </div>

        <div class="flex items-center gap-2">
          <button (click)="hideWalletModal()" class="wallet-modal-close" aria-label="Close modal">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Min / Max Deposit + Level Up badge, all in one row on every
           screen size (same layout on mobile/tablet and web) -->
      <div
        class="flex items-center justify-between flex-nowrap gap-1.5 sm:gap-3 mb-3 sm:mb-5 overflow-x-auto no-scrollbar">
        <div class="wallet-level-badge wallet-level-badge-compact" (click)="goToLevelScreen()">
          <span class="level-title">🚀 Level Up</span>
        </div>
        <div class="flex items-center gap-1.5 sm:gap-3">
          <div class="wallet-info-pill">
            <span class="hidden sm:inline">Min Deposit:</span><span class="sm:hidden">Min:</span>
            <span class="value">${{ minDeposit || 0 }}</span>
          </div>
          <div class="wallet-info-pill">
            <span class="hidden sm:inline">Max Deposit:</span><span class="sm:hidden">Max:</span>
            <span class="value">${{ maxDeposit || 0 }}</span>
          </div>
        </div>
      </div>

      <!-- Choose Account -->
      <div class="mb-3 sm:mb-5">
        <p class="wallet-section-label">Choose Account</p>
        @if (isLoadingPaymentMethods) {
        <div class="pm-grid">
          @for (tile of paymentMethodSkeletonTiles; track $index) {
          <div class="pm-tile pm-tile--skeleton">
            <ngx-skeleton-loader
              [theme]="{ width: '28px', height: '28px', margin: '0', borderRadius: '8px', background: 'rgba(255,255,255,0.08)' }"></ngx-skeleton-loader>
            <ngx-skeleton-loader
              [theme]="{ width: '60px', height: '10px', margin: '0', borderRadius: '6px', background: 'rgba(255,255,255,0.08)' }"></ngx-skeleton-loader>
          </div>
          }
        </div>
        } @else {
        <div class="pm-grid">
          @for (account of AccountType; track account.id) {
          @if (account.name !== "redeemmultiplier" && !(showDisputePopup && (account.name === "GooglePay" || account.name === "ApplePay"))) {
          <div class="pm-tile" [class.is-active]="selectedAccountType === account.name"
            [class.is-disabled]="!account.isActive"
            (click)="togglePayment(account.name, account.isActive, account.kycStatus, $event)">
            <div class="pm-tile__icon">
              <img loading="lazy" [src]="account.bg_image" [alt]="account.name" />
              @if (selectedAccountType === account.name) {
              <span class="pm-tile__check">
                <fa-icon [icon]="faCheck"></fa-icon>
              </span>
              }
            </div>

            <div class="pm-tile__label">
              <span class="pm-tile__name">
                {{ account.name === 'Card2' ? 'CashTap' : (account.name.includes('CashApp') ? 'CashApp' : account.name) }}
              </span>
              @if (!account.isActive) {
              <span class="pm-tile__soon">Coming Soon</span>
              }
            </div>

            @if (account.isActive && account.Bonus != 0 && account.Bonus != 0.0) {
            <span class="pm-tile__bonus">+{{ account.Bonus }}%</span>
            }
          </div>
          }
          }
        </div>
        }
      </div>

      <!-- Promo Code — only shown when the selected payment method's
           IsPromoAvailable flag is true -->
      <div class="mb-3 sm:mb-5" *ngIf="selectedAccountPromoAvailable">
        <p class="wallet-section-label">Have a Promo Code?</p>
        <div class="flex items-center gap-2">
          <div class="wallet-amount-input-wrap flex-1">
            <input type="text" [(ngModel)]="promoCode" placeholder="Enter promo code"
              (keydown.enter)="applyPromoCode()" class="wallet-promo-input" />
          </div>
          <button type="button" (click)="applyPromoCode()" class="wallet-btn-action wallet-btn-promo"
            [disabled]="isApplyingPromo || !promoCode?.trim()">
            @if (isApplyingPromo) {
            <span class="wallet-btn-spinner" aria-hidden="true"></span>
            } @else {
            Apply
            }
          </button>
        </div>
        <div *ngIf="appliedPromoCode" class="wallet-promo-applied-note">
          <fa-icon [icon]="faCheck" class="text-[10px]"></fa-icon>
          Promo code "{{ appliedPromoCode }}" applied
        </div>
        <div *ngIf="promoError" class="wallet-promo-error-note">
          {{ promoError }}
        </div>
      </div>

      <!-- Forms Area -->
      <div class="space-y-3 sm:space-y-4">

      <!-- <div [hidden]="!showcard">
          <div id="card-container"></div>

          <form [formGroup]="paymentFormSquare">
            <div class="mb-3 sm:mb-4">
              <label class="wallet-form-label">Add Amount</label>
              <div class="wallet-amount-input-wrap">
                <span class="prefix">$</span>
                <input type="number" formControlName="amount" (input)="removeLeadingZero($event)"
                  placeholder="0.00" />
              </div>
              <div *ngIf="paymentFormSquare.get('amount')?.invalid && paymentFormSquare.get('amount')?.touched"
                class="text-red-400 text-xs mt-1">
                Amount is required.
              </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-3 sm:mb-4">
              <div class="form-group">
                <label class="wallet-form-label">Full Name</label>
                <input type="text" formControlName="fullName" class="wallet-form-input" placeholder="Full Name" />
              </div>
              <div class="form-group">
                <label class="wallet-form-label">Street Address</label>
                <input type="text" formControlName="streetAddress" class="wallet-form-input"
                  placeholder="Street Address" />
              </div>
              <div class="form-group">
                <label class="wallet-form-label">City</label>
                <input type="text" formControlName="city" class="wallet-form-input" placeholder="City" />
              </div>
              <div class="form-group">
                <label class="wallet-form-label">State</label>
                <input type="text" formControlName="state" class="wallet-form-input" placeholder="State" />
              </div>
              <div class="form-group">
                <label class="wallet-form-label">Zip/Postal</label>
                <input type="number" formControlName="zip" class="wallet-form-input" placeholder="Zip/Postal" />
              </div>
              <div class="form-group">
                <label class="wallet-form-label">Country</label>
                <input type="text" formControlName="country" class="wallet-form-input" placeholder="Country" />
              </div>
            </div>
          </form>

          <div class="flex flex-col sm:flex-row gap-3 w-full">
            <button (click)="hideWalletModal()" class="wallet-btn-cancel">
              Cancel
            </button>
            <button (click)="handlePaymentSquare()" class="wallet-btn-action" [disabled]="isProcessingPayment">
              @if (isProcessingPayment) {
                <span class="wallet-btn-spinner" aria-hidden="true"></span>
                Processing...
              } @else {
                <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
                Add Balance
              }
            </button>
          </div>
        </div> -->

        <div [hidden]="!showcard">
          <div style="background: white; height: 35px; margin: 10px; padding: 10px; border-radius: 8px;"
            [hidden]="!stripeCardUi">
            <div id="card-element"></div>
          </div>

          <form [formGroup]="squareForm" *ngIf="!stripeCardUi">
            <div class="mb-3 sm:mb-4">
              <label class="wallet-form-label">Add Amount</label>
              <div class="wallet-amount-input-wrap">
                <span class="prefix">$</span>
                <input type="number" formControlName="amount" (input)="removeLeadingZero($event)" placeholder="0.00" />
              </div>
              <div *ngIf="squareForm.get('amount')?.invalid && squareForm.get('amount')?.touched"
                class="text-red-400 text-xs mt-1">
                Amount is required.
              </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-3 sm:mb-4">
              <div class="form-group">
                <label class="wallet-form-label">Email</label>
                <input type="email" formControlName="email" class="wallet-form-input" placeholder="Email" />
                <div *ngIf="squareForm.get('email')?.invalid && squareForm.get('email')?.touched"
                  class="text-red-400 text-xs mt-1">
                  Valid email is required.
                </div>
              </div>
              <div class="form-group">
                <label class="wallet-form-label">Biller Name</label>
                <input type="text" formControlName="billerName" class="wallet-form-input" placeholder="Biller Name" />
                <div *ngIf="squareForm.get('billerName')?.invalid && squareForm.get('billerName')?.touched"
                  class="text-red-400 text-xs mt-1">
                  Biller name is required.
                </div>
              </div>
              <div class="form-group">
                <label class="wallet-form-label">Address Line 1</label>
                <input type="text" formControlName="addressLine1" class="wallet-form-input" placeholder="Address Line 1" />
                <div *ngIf="squareForm.get('addressLine1')?.invalid && squareForm.get('addressLine1')?.touched"
                  class="text-red-400 text-xs mt-1">
                  Address line 1 is required.
                </div>
              </div>
              <div class="form-group">
                <label class="wallet-form-label">Address Line 2</label>
                <input type="text" formControlName="addressLine2" class="wallet-form-input" placeholder="Address Line 2" />
                <div *ngIf="squareForm.get('addressLine2')?.invalid && squareForm.get('addressLine2')?.touched"
                  class="text-red-400 text-xs mt-1">
                  Address line 2 is required.
                </div>
              </div>
              <div class="form-group">
                <label class="wallet-form-label">City</label>
                <input type="text" formControlName="city" class="wallet-form-input" placeholder="City" />
                <div *ngIf="squareForm.get('city')?.invalid && squareForm.get('city')?.touched"
                  class="text-red-400 text-xs mt-1">
                  City is required.
                </div>
              </div>
              <div class="form-group">
                <label class="wallet-form-label">State</label>
                <input type="text" formControlName="state" class="wallet-form-input" placeholder="State" />
                <div *ngIf="squareForm.get('state')?.invalid && squareForm.get('state')?.touched"
                  class="text-red-400 text-xs mt-1">
                  State is required.
                </div>
              </div>
              <div class="form-group">
                <label class="wallet-form-label">Zip</label>
                <input type="number" formControlName="zip" class="wallet-form-input" placeholder="Zip" />
                <div *ngIf="squareForm.get('zip')?.invalid && squareForm.get('zip')?.touched"
                  class="text-red-400 text-xs mt-1">
                  Zip is required.
                </div>
              </div>
              <div class="form-group">
                <label class="wallet-form-label">Postal Code</label>
                <input type="text" formControlName="postalCode" class="wallet-form-input" placeholder="Postal Code" />
                <div *ngIf="squareForm.get('postalCode')?.invalid && squareForm.get('postalCode')?.touched"
                  class="text-red-400 text-xs mt-1">
                  Postal code is required.
                </div>
              </div>
              <div class="form-group">
                <label class="wallet-form-label">Country</label>
                <input type="text" formControlName="country" class="wallet-form-input" placeholder="Country" />
                <div *ngIf="squareForm.get('country')?.invalid && squareForm.get('country')?.touched"
                  class="text-red-400 text-xs mt-1">
                  Country is required.
                </div>
              </div>
            </div>
          </form>

          <div class="flex flex-col sm:flex-row gap-3 w-full" *ngIf="!stripeCardUi">
            <button (click)="hideWalletModal()" class="wallet-btn-cancel">
              Cancel
            </button>
            <button (click)="createStripeCardPayment()" class="wallet-btn-action" [disabled]="isProcessingPayment">
              @if (isProcessingPayment) {
                <span class="wallet-btn-spinner" aria-hidden="true"></span>
                Processing...
              } @else {
                <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
                Pay Securely
              }
            </button>
          </div>

          <div class="flex flex-col sm:flex-row gap-3 w-full" *ngIf="stripeCardUi">
            <button (click)="hideWalletModal()" class="wallet-btn-cancel">
              Cancel
            </button>
            <button (click)="stripeCardAuthenticate()" class="wallet-btn-action" [disabled]="isProcessingPayment">
              @if (isProcessingPayment) {
                <span class="wallet-btn-spinner" aria-hidden="true"></span>
                Processing...
              } @else {
                Add
              }
            </button>
          </div>
        </div>

        <!-- Cash App -->
        <div [hidden]="!showcashApp">
          <div class="payment-wrapper">
            <div [hidden]="!cashAppPayInitialized" class="flex justify-center mb-4 sm:mb-6">
              <div id="cash-app-pay-container" class="mx-auto"></div>
            </div>

            <div [hidden]="cashAppPayInitialized">
              <form [formGroup]="squareForm" class="mb-3 sm:mb-4">
                <div class="mb-3 sm:mb-4">
                  <label class="wallet-form-label">Add Amount</label>
                  <div class="wallet-amount-input-wrap">
                    <span class="prefix">$</span>
                    <input type="number" formControlName="amount" (input)="removeLeadingZero($event)"
                      placeholder="0.00" />
                  </div>
                  <div *ngIf="squareForm.get('amount')?.invalid && squareForm.get('amount')?.touched"
                    class="text-red-400 text-xs mt-1">
                    Amount is required.
                  </div>
                </div>
              </form>

              <div class="flex flex-col sm:flex-row gap-3 w-full">
                <button (click)="hideWalletModal()" class="wallet-btn-cancel">
                  Cancel
                </button>
                <button (click)="whopPayment('whop,cashapp')" [disabled]="squareForm.invalid || isProcessingPayment"
                  class="wallet-btn-action">
                  @if (isProcessingPayment) {
                    <span class="wallet-btn-spinner" aria-hidden="true"></span>
                    Processing...
                  } @else {
                    Pay Securely
                  }
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Manual / Chime / Zelle / Venmo etc -->
        <div *ngIf="showChimeZelle">
          @if (selectedAccountType == "Paypal") {
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3 sm:gap-4 sm:mb-4 items-start">
            <div class="form-group">
              <label class="wallet-form-label">Add Amount</label>
              <div class="wallet-amount-input-wrap">
                <span class="prefix">$</span>
                <input type="number" [(ngModel)]="newBalance" (input)="removeLeadingZero($event)" placeholder="0.00" />
              </div>
            </div>

            <div class="relative w-full form-group">
              <label class="wallet-form-label">Account Title</label>
              <div class="wallet-select-field" [class.wallet-select-field-open]="accountTitleDropdownOpen"
                (click)="accountTitleDropdownOpen = !accountTitleDropdownOpen">
                <span class="field-value" [ngClass]="selectedAccounttitle ? '' : 'field-placeholder'">
                  {{ selectedAccounttitle || "Choose Account Title" }}
                </span>
                <svg class="field-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <i *ngIf="selectedAccounttitle" (click)="CopyToClipBoard(selectedAccounttitle)"
                class="fa-regular fa-copy absolute right-10 top-[67%] -translate-y-1/2 p-1 cursor-pointer text-[var(--modal-text-purple)] hover:text-white"></i>

              <ul *ngIf="accountTitleDropdownOpen" class="wallet-dropdown-list">
                <li *ngFor="let accounts of accountsTitle; trackBy: trackByIndex"
                  [class.opacity-50]="accounts.accountDetail === 'No data found'"
                  [class.cursor-not-allowed]="accounts.accountDetail === 'No data found'"
                  (click)="accounts.accountDetail !== 'No data found' ? selectAccountTitle(accounts) : null">
                  {{ accounts.AccountTitle }}
                </li>
              </ul>
            </div>
          </div>

          <div class="wallet-paypal-note">
            <svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            Pay only Family and Friends
          </div>
          } @else {
          <div class="mb-3 sm:mb-4">
            <label class="wallet-form-label">Enter Amount</label>
            <div class="wallet-amount-input-wrap">
              <span class="prefix">$</span>
              <input type="number" [(ngModel)]="newBalance" (input)="removeLeadingZero($event)" placeholder="0.00" />
            </div>
          </div>

          <div class="mb-3 sm:mb-4 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 items-start" *ngIf="
              selectedAccountType !== 'GooglePay' &&
              selectedAccountType !== 'ApplePay' &&
              selectedAccountType !== 'CashApp2' &&
              selectedAccountType !== 'Card2'
            ">
            <div class="relative w-full form-group">
              <label class="wallet-form-label">Account Title</label>
              <div class="wallet-select-field" [class.wallet-select-field-open]="accountTitleDropdownOpen"
                (click)="accountTitleDropdownOpen = !accountTitleDropdownOpen">
                <span class="field-value" [ngClass]="selectedAccounttitle ? '' : 'field-placeholder'">
                  {{ selectedAccounttitle || "Choose Account Title" }}
                </span>
                <svg class="field-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <i *ngIf="selectedAccounttitle" (click)="CopyToClipBoard(selectedAccounttitle)"
                class="fa-regular fa-copy absolute right-10 top-[67%] -translate-y-1/2 p-1 cursor-pointer text-[var(--modal-text-purple)] hover:text-white"></i>

              <ul *ngIf="accountTitleDropdownOpen" class="wallet-dropdown-list">
                <li *ngFor="let accounts of accountsTitle; trackBy: trackByIndex"
                  [class.opacity-50]="accounts.accountDetail === 'No data found'"
                  [class.cursor-not-allowed]="accounts.accountDetail === 'No data found'"
                  (click)="accounts.accountDetail !== 'No data found' ? selectAccountTitle(accounts) : null">
                  {{ accounts.AccountTitle }}
                </li>
              </ul>
            </div>

            @if (selectedAccountType !== "Paypal") {
            <div class="flex flex-col w-full relative form-group">
              <label class="wallet-form-label">Account Number / Tag</label>
              <input type="text" placeholder="Choose Account Number / Tag" [value]="CustomerTag" [disabled]="true"
                class="wallet-form-input pr-10" />
              <i *ngIf="CustomerTag != ''" (click)="CopyToClipBoard(CustomerTag)"
                class="fa-regular fa-copy absolute right-3 top-1/2 -translate-y-1/2 p-1 cursor-pointer text-[var(--modal-text-purple)] hover:text-white mt-2">
              </i>
            </div>
            }
          </div>
          }

          @if (selectedAccountType === "Paypal" && showPayPalFields) {
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3 sm:gap-4 sm:mb-4">
            <div class="relative w-full form-group">
              <label class="wallet-form-label">Email</label>
              <input type="text" readonly class="wallet-form-input" placeholder="Email" [value]="payPalDetails.Email" />
              <i *ngIf="payPalDetails.Email != ''" (click)="CopyToClipBoard(payPalDetails.Email)"
                class="fa-regular fa-copy absolute right-3 top-[65%] -translate-y-1/2 p-1 cursor-pointer text-[var(--modal-text-purple)] hover:text-white"></i>
            </div>
            <div class="relative w-full form-group">
              <label class="wallet-form-label">Redirect Link</label>
              <input type="text" readonly class="wallet-form-input" placeholder="Link" [value]="payPalDetails.Link" />
              <i (click)="RedirectToLink(payPalDetails.Link)"
                class="fa-solid fa-arrow-up-right-from-square absolute right-3 top-[65%] -translate-y-1/2 p-1 cursor-pointer text-[var(--modal-text-purple)] hover:text-white"></i>
            </div>
          </div>
          }

          @if (selectedAccountType === "Card2") {
          <div class="grid grid-cols-1 gap-3 mb-3 sm:gap-4 sm:mb-4">
            <div class="relative w-full form-group">
              <label class="wallet-form-label">Payment Link</label>
              <div class="wallet-amount-input-wrap">
                <input type="text" readonly class="wallet-form-input pr-16"
                  value="https://cashtap.cash/pay/gamingzone" />
              </div>
              <div
                class="absolute right-3 top-[65%] -translate-y-1/2 flex items-center gap-3 text-[var(--modal-text-purple)]">
                <i (click)="CopyToClipBoard('https://cashtap.cash/pay/gamingzone')"
                  class="fa-regular fa-copy cursor-pointer hover:text-white" title="Copy to clipboard"></i>
                <i (click)="RedirectToLink('https://cashtap.cash/pay/gamingzone')"
                  class="fa-solid fa-arrow-up-right-from-square cursor-pointer hover:text-white" title="Open link"></i>
              </div>
            </div>
          </div>
          }

          <div class="grid grid-cols-1 sm:grid-cols-1 gap-3 mb-3 sm:gap-4 sm:mb-4">
            <div class="form-group">
              <label class="wallet-form-label">Add Email</label>
              <div class="wallet-amount-input-wrap">
                <input type="text" [(ngModel)]="email" class="wallet-form-input" placeholder="Add Email" />
              </div>
            </div>
          </div>

          <!-- Upload Receipt -->
          <div class="flex flex-col sm:flex-row justify-between gap-3 sm:gap-4 mb-3 sm:mb-5">
            <div>
              <label class="wallet-form-label">Upload Deposit Receipt</label>
              <div class="flex items-start">
                <input id="receipt" type="file" (change)="onFileSelected($event)" class="hidden" accept="image/*" />
                <label for="receipt" class="wallet-upload-btn">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                  </svg>
                  Deposit Receipt
                </label>

                <div *ngIf="uploadProfileImage" class="relative w-32 ml-3">
                  <img loading="lazy" [src]="uploadProfileImage" alt="Selected Image"
                    class="w-full max-h-28 rounded-lg border border-[var(--modal-border)] object-cover" />
                  <button (click)="clearSelection()"
                    class="absolute top-0 right-0 bg-gray-800 text-white rounded-full p-1 hover:bg-red-500 transition transform translate-x-1/2 -translate-y-1/2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="qrCodeImage && qrCodeImage != ''">
              <label class="wallet-form-label">QR Code (Click to Expand)</label>
              <img loading="lazy" [src]="qrCodeImage" alt="QR Code"
                class="w-32 max-h-28 rounded-lg border border-[var(--modal-border)] object-contain cursor-pointer"
                (click)="openQrPopup()" />
            </div>
          </div>

          <!-- Buttons -->
          <div class="flex flex-col sm:flex-row gap-3 w-full" *ngIf="
            selectedAccountType !== 'GooglePay' &&
            selectedAccountType !== 'ApplePay' &&
            selectedAccountType !== 'CashApp2' &&
            selectedAccountType !== 'Card2'
          ">
            <button (click)="hideWalletModal()" class="wallet-btn-cancel">
              Cancel
            </button>
            <button (click)="addBalance()" class="wallet-btn-action" [disabled]="isProcessingPayment">
              @if (isProcessingPayment) {
                <span class="wallet-btn-spinner" aria-hidden="true"></span>
                Processing...
              } @else {
                <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
                Pay Securely
              }
            </button>
          </div>

          <div class="flex flex-col sm:flex-row gap-3 w-full" *ngIf="
            selectedAccountType === 'GooglePay' ||
            selectedAccountType === 'ApplePay' ||
            selectedAccountType === 'CashApp2' ||
            selectedAccountType === 'Card2'
          ">
            <button (click)="hideWalletModal()" class="wallet-btn-cancel">
              Cancel
            </button>
            <button (click)="AddAppleGoogleCashApp2Pay()" class="wallet-btn-action" [disabled]="isProcessingPayment">
              @if (isProcessingPayment) {
                <span class="wallet-btn-spinner" aria-hidden="true"></span>
                Processing...
              } @else {
                Pay Securely
              }
            </button>
          </div>
        </div>

        <!-- Cash app taptap -->
        @if (
        selectedAccountType === "CashApp2" ||
        selectedAccountType === "GooglePay" ||
        selectedAccountType === "ApplePay"
        ) {
        <div>
          <div class="payment-wrapper">
            <div>
              <div class="mb-3 sm:mb-4">
                <div class="mb-3 sm:mb-4">
                  <label class="wallet-form-label">Select Amount</label>
                  <!-- Amount chips (replace the amount dropdowns); same selectAmount() as before -->
                  <div class="amount-grid" role="radiogroup" aria-label="Choose amount">
                    @for (amt of (selectedAccountType === "CashApp2" ? cashAppAmounts : googleApplePayAmounts); track amt) {
                    <button type="button" class="amount-chip" role="radio"
                      [class.is-active]="+newBalance === amt" [attr.aria-checked]="+newBalance === amt"
                      (click)="selectAmount(amt)">
                      ${{ amt % 1 === 0 ? amt : (amt | number: '1.2-2') }}
                    </button>
                    }
                  </div>
                </div>
              </div>

              <div class="flex flex-col sm:flex-row gap-3 w-full">
                <button (click)="hideWalletModal()" class="wallet-btn-cancel">
                  Cancel
                </button>
                <button (click)="AddTapTapCashApp()" [disabled]="!newBalance || isProcessingPayment"
                  class="wallet-btn-action">
                  @if (isProcessingPayment) {
                    <span class="wallet-btn-spinner" aria-hidden="true"></span>
                    Processing...
                  } @else {
                    Pay Securely
                  }
                </button>
              </div>
            </div>
          </div>
        </div>
        }
      </div>

      <!-- Security Note -->
      <div class="wallet-security-note">
        <svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0110 0v4" />
        </svg>
        Your payment is 100% secure and encrypted
      </div>

      <!-- Bottom spacer -->
      <div class="h-3 sm:h-6"></div>
    </div>
  </div>
</div>

@if (isCopied()) {
<div
  class="fixed bottom-[15%] left-1/2 transform -translate-x-1/2 bg-[#2C2C2C] text-white px-5 py-3 rounded-lg shadow-[0_4px_10px_rgba(0,0,0,0.2)] transition-opacity duration-300 z-[999] flex items-center gap-3 border border-[#3A3A3A]">
  <fa-icon [icon]="faCheck" class="text-[#4CAF50] text-lg"></fa-icon>
  <span class="text-sm font-medium">Copied to clipboard</span>
</div>
}

<!-- KYC Popup -->
<app-kyc-popup *ngIf="showKycPopup" [title]="popupTitle" [message]="popupMessage" [buttonText]="popupButtonText"
  [redirectRoute]="popupRedirect" (close)="closeKycPopup()">
</app-kyc-popup>